import LegacyConfigs from './configs';
import LegacyDirectives from './directives';
import LegacyFilters from './filters';
import LegacyServices from './services';
import LegacyTemplates from './partials';

export const Legacy = angular.module('legacy-app', [
    'ngResource',
    'ngSanitize',
    'ngTouch',

    LegacyConfigs.name,
    LegacyDirectives.name,
    LegacyFilters.name,
    LegacyServices.name,
    LegacyTemplates.name
])
.constant('$', window.$)
.constant('_', window._)
.constant('LsCache', window.lscache)
.constant('LZString', window.LZString);

export default Legacy;
